export default "__VITE_ASSET__CXF2caXC__"